var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "index-chart",
      attrs: { "element-loading-text": "数据加载中" },
    },
    [
      _c(
        "div",
        { staticClass: "chart-header" },
        [
          _c("div", { staticClass: "view-title" }, [
            _c("div", { staticClass: "view-switch-wrap" }, [
              _c(
                "div",
                {
                  staticClass: "view-switch-item",
                  class: [_vm.OrderType == 1 ? "view-switch-item-active" : ""],
                  on: {
                    click: function ($event) {
                      _vm.OrderType = 1
                    },
                  },
                },
                [_vm._v(" ERP订单 ")]
              ),
              _c(
                "div",
                {
                  staticClass: "view-switch-item",
                  class: [_vm.OrderType == 2 ? "view-switch-item-active" : ""],
                  on: {
                    click: function ($event) {
                      _vm.OrderType = 2
                    },
                  },
                },
                [_vm._v(" 1688平台订单 ")]
              ),
            ]),
          ]),
          _c(
            "el-form",
            {
              staticClass: "chart-form",
              attrs: { inline: true, model: _vm.query },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.timeChange },
                    model: {
                      value: _vm.query.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "time", $$v)
                      },
                      expression: "query.time",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "veiw-charts-container" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 18 } }, [
                _c("div", { staticClass: "grid-content bg-purple-dark" }, [
                  _c("div", {
                    staticStyle: { height: "400px", "margin-top": "50px" },
                    attrs: { id: "container" },
                  }),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "view-progress-wrap" }, [
                  _c(
                    "div",
                    {
                      staticClass: "view-progress-item",
                      attrs: { id: "view-progress-old" },
                    },
                    [
                      _c("el-progress", {
                        attrs: {
                          type: "circle",
                          "stroke-width": 12,
                          color: "#ff5500",
                          percentage: _vm.OldCustomer,
                        },
                      }),
                      _c("p", { staticClass: "cril-title" }, [
                        _vm._v("老客占比"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "view-progress-item",
                      attrs: { id: "view-progress-reshopping" },
                    },
                    [
                      _c("el-progress", {
                        attrs: {
                          "stroke-width": 12,
                          type: "circle",
                          color: "#88CC96",
                          percentage: _vm.RepurchaseRate,
                        },
                      }),
                      _c("p", { staticClass: "cril-title" }, [
                        _vm._v("复购率"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }